var _path, _rect, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSlide2 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 211,
    viewBox: "0 0 364 211",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.294 120V13.2588C200.294 9.94511 197.608 7.25882 194.294 7.25882H7C3.68629 7.25882 1 9.94511 1 13.2588V155C1 158.314 3.68629 161 7 161H141.5M200.294 129V155C200.294 158.314 197.608 161 194.294 161H149.5",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 232.611,
    y: 48.1177,
    width: 130.388,
    height: 104.765,
    rx: 5,
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1 14.9999C1 10.5817 4.58172 6.99994 9 6.99994H192C196.418 6.99994 200 10.5817 200 14.9999V36.9999H1V14.9999Z",
    fill: "#5b5eff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 37.1529H200.294",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M261.506 119.553L285.431 91.6852L304.406 105.619L334.106 73.9999",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 179.147,
    cy: 152.147,
    r: 38.1471,
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.646 151.941C210.646 169.047 196.558 182.941 179.146 182.941C161.735 182.941 147.646 169.047 147.646 151.941C147.646 134.835 161.735 120.941 179.146 120.941C196.558 120.941 210.646 134.835 210.646 151.941Z",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M204.146 180.941L229.646 208.941C231.646 210.941 238.646 206.941 237.146 201.441C231.146 195.941 217.646 183.941 208.646 176.441",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M229.646 208.941L204.146 180.941L208.646 176.441C217.646 183.941 231.146 195.941 237.146 201.441C238.646 206.941 231.646 210.941 229.646 208.941Z",
    fill: "#5b5eff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M253.677 174.523H344.071M253.677 187.335H324.853M253.677 200.859H304.212",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M257.691 2.74258L239.298 31.2208C238.439 32.5516 239.394 34.3059 240.978 34.3059H277.763C279.347 34.3059 280.302 32.5516 279.443 31.2208L261.051 2.74259C260.263 1.52265 258.478 1.52265 257.691 2.74258Z",
    stroke: "#5b5eff",
    strokeWidth: 2
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M257.691 2.74258L239.298 31.2208C238.439 32.5516 239.394 34.3059 240.978 34.3059H277.763C279.347 34.3059 280.302 32.5516 279.443 31.2208L261.051 2.74259C260.263 1.52265 258.478 1.52265 257.691 2.74258Z",
    fill: "#5b5eff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M259.371 9.39412V20.7824M259.371 25.7647V27.9",
    stroke: "#5b5eff",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSlide2);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/slide-2.fed6f6e6d87cdd7f3fae80c7bf719eb6.svg";